import { RAK7240 } from './types'

export default {
  [RAK7240]: '1.3.4_RAK b113',
}
